import React, { Component, Fragment } from "react";

import Typography from "@material-ui/core/Typography";

import MyButton from "../util/MyButton";

import AddTodo from "./todoList/AddTodo";
import VisibleTodoList from "./todoList/VisibleTodoList";
import Footer from "./todoList/Footer";

//Redux
import { connect } from "react-redux";
import { editUserDetails } from "../redux/actions/userActions";

//Mui
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Hidden from "@material-ui/core/Hidden";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

export class GpaCalculator extends Component {
    state = {
        open: false,
        row: 2,
        grade: null,
        result: "hide"
    };
    handleOpen = () => {
        this.setState({ open: true });
    };
    handleClose = () => {
        this.setState({ open: false });
    };

    handleCalculate = () => {
        console.log();
        let grade = 0;
        let credit = 0;
        let currentpa = 0;
        for (var i = 0; i < this.state.row; i++) {
            currentpa +=
                document.getElementById("aa" + i).value *
                document.getElementById("ab" + i).value;
            credit += document.getElementById("ab" + i).value * 1;
        }
        console.log(currentpa);
        console.log(credit);
        grade = currentpa / credit;
        this.setState({ grade: grade, result: "show" });
        //console.log(grade);
    };

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    handleAdd = () => {
        let currentRow = this.state.row;
        currentRow += 1;
        this.setState({
            row: currentRow
        });
    };

    handleRemove = () => {
        let currentRow = this.state.row;
        currentRow -= 1;
        if (currentRow < 0) {
            currentRow = 0;
        }
        this.setState({
            row: currentRow
        });
    };

    addRow = () => {
        let currentRow = this.state.row;
        currentRow += 1;
        this.setState({ row: currentRow });
    };

    render() {
        const items = [];

        for (var i = 0; i < this.state.row; i++) {
            items.push(
                <TableRow>
                    <TableCell component="th" scope="row">
                        <input type="text" id={`aa${i}`} />
                    </TableCell>
                    <TableCell align="right">
                        <input type="text" id={`ab${i}`} />
                    </TableCell>
                </TableRow>
            );
        }
        return (
            <Fragment>
                <Button onClick={this.handleOpen} color="inherit">
                    GPA Calculator
                </Button>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle> </DialogTitle>
                    <DialogContent>
                        {this.state.result == "show" ? (
                            <Typography>Grade = {this.state.grade}</Typography>
                        ) : (
                            <br></br>
                        )}

                        <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">
                                            Subject Credit
                                        </TableCell>
                                        <TableCell align="center">
                                            Grade Obtained
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>{items}</TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.handleAdd} color="primary">
                            + Add
                        </Button>
                        <Button onClick={this.handleRemove} color="primary">
                            - Remove
                        </Button>
                        <Button
                            onClick={this.handleCalculate}
                            color="secondary"
                        >
                            Calculate
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

export default GpaCalculator;
